import type { FC } from "react";

import ChevronDown from "@/assets/icons/chevron-down";
import RiskIcon from "@/components/layout/risk-icon";
import { cn } from "@/lib/utils";
import type { Risk } from "@/utils/patient";
import { getRiskLabel } from "@/utils/patient";

type RiskLabelProps = {
  risk: Risk | "tooth";
  color: "error" | "warning" | "success" | "neutral" | "errorDisease";
  text?: string;
  isDropdown?: boolean;
  className?: string;
};

const getLabelColors = (
  color: "error" | "warning" | "success" | "neutral" | "errorDisease"
) => {
  switch (color) {
    case "errorDisease":
      return ["bg-pink-50", "border-pink-200", "#BE185D"];
    case "error":
      return ["bg-error-50", "border-error-200", "#B91C1C"];
    case "warning":
      return ["bg-warning-50", "border-warning-200", "#C2410C"];
    case "success":
      return ["bg-success-50", "border-success-200", "#15803D"];
    case "neutral":
      return ["bg-gray-50", "border-gray-200", "#334155"];
  }
};

const RiskLabel: FC<RiskLabelProps> = ({
  risk,
  color,
  text,
  isDropdown = false,
  className,
}) => {
  const colors = getLabelColors(color);
  return (
    <div
      className={cn([
        "flex gap-1 items-center border rounded-2xl py-[2px] px-2",
        colors[0],
        colors[1],
        className,
      ])}
      title={risk !== "tooth" ? getRiskLabel(risk) : text}
    >
      <RiskIcon risk={risk} color={colors[2]} />
      {text ? <div className={"text-black font-medium"}>{text}</div> : null}
      {isDropdown ? <ChevronDown /> : null}
    </div>
  );
};

export default RiskLabel;
